// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__1_ezr","gobi":"About_gobi__3IKRE","info":"About_info__2u1gD","images":"About_images__1INLp","hide":"About_hide__30kpI"};